import React from 'react';
import s from './Button.module.scss';

type ButtonProps = {
  label: string;
  onClick: () => void;
  className?: string;
};

const Button: React.FC<ButtonProps> = ({ label, onClick, className }) => {
  return (
    <button className={`${s.root} ${className || ''}`} onClick={onClick}>
      {label}
    </button>
  );
};

export default Button;
